import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS]
		.GET_WORKS_MATERIAL_CONSUMPTION_RATE_NORMS]: {
		url: '/company/:companyId/works_material_consumption_rate_norms/',
	},
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS]
		.GET_WORKS_MATERIAL_CONSUMPTION_RATE_NORM]: {
		url: '/company/:companyId/works_material_consumption_rate_norms/:worksMaterialConsumptionRateNormId/',
	},
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS]
		.CREATE_WORKS_MATERIAL_CONSUMPTION_RATE_NORM]: {
		url: '/company/:companyId/works_material_consumption_rate_norms/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS]
		.PATCH_WORKS_MATERIAL_CONSUMPTION_RATE_NORM]: {
		url: '/company/:companyId/works_material_consumption_rate_norms/:worksMaterialConsumptionRateNormId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS]
		.PUT_WORKS_MATERIAL_CONSUMPTION_RATE_NORM]: {
		url: '/company/:companyId/works_material_consumption_rate_norms/:worksMaterialConsumptionRateNormId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS]
		.DELETE_WORKS_MATERIAL_CONSUMPTION_RATE_NORM]: {
		url: '/company/:companyId/works_material_consumption_rate_norms/:worksMaterialConsumptionRateNormId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
